import React from 'react'
import styled from 'styled-components'
import { View, Text } from '@olxbr/design-system'

import CheckCircleSymbol from '../../atoms/CheckCircleSymbol'
import Subtitle from '../../atoms/Subtitle'
import TextCallout from '../../molecules/TextCallout'
import { fontH3 } from '../../../util/font'
import medias from '../../../util/medias'

const Content = styled(View)`
  display: flex;
  flex-direction: row;
  width: 100%;
`

const Wrapper = styled(View)`
  margin-left: 36px;
`

const WrapperDescription = styled(View)`
  margin-top: 16px;
  max-width: 464px;
`

const Description = styled(Subtitle)`
  margin-top: 16px;
  ${medias.fontMax`font-size: 16px;`};
  ${medias.fontMin`font-size: 14px;`};
`

const Title = styled(Text)`
  ${fontH3};
  font-weight: 700;
`

const WrapperLink = styled(View)`
  display: flex;
  margin-top: 8px;
  align-items: flex-start;
`

const EmailVerified = ({ onMyAccountClick }) => (
  <Content>
    <CheckCircleSymbol />
    <Wrapper>
      <Title>E-mail verificado com sucesso!</Title>
      <WrapperDescription>
        <Description>
          Seja confiável e fortaleça o seu perfil. Compradores confiam mais em vendedores com
          telefone e e-mail verificados e Facebook conectado.
        </Description>
      </WrapperDescription>
      <WrapperLink>
        <TextCallout text="Ir para" linkText="Meu Cadastro" onClick={onMyAccountClick} />
      </WrapperLink>
    </Wrapper>
  </Content>
)

export default EmailVerified
